import { DateTime } from "luxon";
import { RecalledValue } from "./RecalledValue";
import { RecallType } from "./RecallType";
import { cDateFormatToLuxon } from "../utils/time";

export class TimeRecalledValue extends RecalledValue {
    time: DateTime;

    constructor(time: DateTime) {
        super();
        this.time = time;
    }

    evaluateProperty(
        mode: RecallType,
        property: string,
        parameters: string[],
    ): string | RecalledValue {
        if (!this.time) {
            return "";
        }

        switch (property) {
            case "code":
                return this.toCode();
            case "text":
                return this.toText();
            case "hour":
                return this.time.toFormat("H");
            case "minute":
                return this.time.toFormat("m");
            case "second":
                return this.time.toFormat("s");
            case "value":
                return this.time.toFormat("tt");
            case "format":
                // Flatten because time format is already given as array, but piping/index.ts nests params into an array
                return this.time.toFormat(cDateFormatToLuxon(parameters.flat()[0]));
            default:
                return this;
        }
    }

    toCode(): string {
        return this.time.toFormat("X");
    }

    toText(): string {
        return this.time.toFormat("t");
    }
}
